<div *ngIf="loading || isLoading" class="screen_loader animate__animated absolute inset-0 z-[35] grid place-content-center bg-[#fafafa] opacity-65 dark:bg-[#060818]">
  <img class="ml-[5px] h-auto w-20 flex-none" src="/assets/images/loader.svg" alt="" />
</div>

<div *ngIf="items">
  <div class="relative">
    <div class="panel border-[#e0e6ed] px-0 pb-1.5 dark:border-[#1b2e4b]">
      <div class="datatable invoice-table px-5">
        <div class="mb-4.5 flex flex-col gap-5 md:flex-row md:items-center">
          <app-search-input (searchChanged)="setSearchText($event)"></app-search-input>

          <div class="ltr:ml-auto rtl:mr-auto"></div>
          <a *appHasRole="[userRole.SuperAdmin]" class="btn btn-outline-primary cursor-pointer gap-2" (click)="addTask()"> <icon-plus /> {{ "contract.add_contract" | translate }} </a>

          <button class="btn btn-primary cursor-pointer gap-2" (click)="forceCheckUpdate()"><icon-refresh /> {{ "contract.force_check_update" | translate }}</button>

          <div class="flex gap-4">
            <div hlMenu class="dropdown">
              <button hlMenuButton type="button" class="flex items-center rounded-md border border-[#e0e6ed] px-4 py-2 text-sm font-semibold dark:border-[#253b5c] dark:bg-[#1b2e4b] dark:text-white-dark">
                <span class="ltr:mr-1 rtl:ml-1">{{ "table_columns" | translate }}</span>
                <icon-caret-down class="h-5 w-5" />
              </button>
              <ul *hlMenuItems @toggleAnimation class="w-max left-0 sm:right-0 sm:left-auto">
                <ng-container *ngFor="let col of cols; index as i">
                  <li>
                    <div class="flex items-center px-4 py-1">
                      <label [for]="'chk-' + i" class="mb-0 cursor-pointer">
                        <input type="checkbox" [id]="'chk-' + i" class="form-checkbox" [ngModel]="!col.hide" (ngModelChange)="col.hide = $event" (change)="updateColumn(col)" />
                        <span class="ltr:ml-2 rtl:mr-2">{{ col.title }}</span>
                      </label>
                    </div>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>

        <app-global-table-filters [filterType]="filterType" [total]="total" [rejected]="invalidCount" [isUsers]="true" (selectionChange)="onSelectionChangeUnified($event.filterType)"></app-global-table-filters>

        <ng-datatable
          #datatable
          [rows]="items"
          [columns]="cols"
          [sortable]="true"
          [isServerMode]="true"
          [page]="pageNumber"
          [search]="search"
          [pageSize]="pageSize"
          [totalRows]="totalRows"
          [sortColumn]="sortColumn"
          [sortDirection]="sortDirection"
          (changeServer)="changeServer($event)"
          skin="whitespace-nowrap bh-table-hover"
          [paginationInfo]="'paginationInfoLabel' | translate"
        >
          <ng-template slot="customerName" let-value="data">
            <div class="flex items-center font-semibold">
              {{ value.customer.name }}
            </div>
          </ng-template>
          <ng-template slot="agencyName" let-value="data">
            <div class="font-semibold">{{ value.customer.name }}</div>
          </ng-template>
          <ng-template slot="domainName" let-value="data">
            <a *ngIf="value?.instance?.domainName" class="cursor-pointer font-semibold text-primary" target="_blank" [href]="'https://' + (value?.instance?.domainName || '')">
              {{ value?.instance?.domainName }}
            </a>
          </ng-template>
          <ng-template slot="createdDate" let-value="data">
            <div class="font-semibold">
              {{ value.createdDate | date: "dd.MM.yyyy" }}
            </div>
          </ng-template>

          <ng-template slot="contractType" let-value="data">
            <span class="badge whitespace-nowrap" [ngClass]="getContractTypeColor(value.contractType)">
              {{ getContractTypeText(value.contractType) }}
            </span>
          </ng-template>

          <ng-template slot="validUntil" let-value="data">
            <div class="font-semibold">
              {{ value.validUntil | date: "dd.MM.yyyy" }}
            </div>
          </ng-template>
          <ng-template slot="email" let-value="data">
            <div class="font-semibold">{{ value.email }}</div>
          </ng-template>
          <ng-template slot="contractTitle" let-value="data">
            <div class="font-semibold">{{ value.package.title }}</div>
          </ng-template>
          <ng-template slot="instanceStatus" let-value="data">
            <div class="font-semibold">
              {{ getInstanceStatusText(value.instance?.status) }}
            </div>
          </ng-template>
          <ng-template slot="update" let-value="data">
            <button (click)="updateSoftware(value)" *ngIf="value.updateAvailable" class="btn btn-success btn-sm">
              {{ "contract.update_software" | translate }}
            </button>
          </ng-template>
          <ng-template slot="actions" let-value="data">
            <div class="flex w-max items-center justify-between">
              <div hlMenu class="dropdown">
                <a hlMenuButton href="javascript:;">
                  <icon-horizontal-dots class="rotate-90 opacity-70" />
                </a>
                <div #dropdownPlaceholder *hlMenuItems>
                  <app-message-portal #messagePortalComponent @toggleAnimation (portalAttached)="onPortalAttached()">
                    <li>
                      <a [routerLink]="['/users/', value.id]" *hlMenuItem="let menuItem">
                        <icon-eye-open class="h-4.5 w-4.5 shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "details_quick_label" | translate }}
                      </a>
                    </li>
                    <div *ngIf="value.instance">
                      <li *ngIf="value.instance.status">
                        <a href="javascript:;" *hlMenuItem="let menuItem" (click)="startInstance(value.id)">
                          <icon-play-circle class="shrink-0 ltr:mr-2 rtl:ml-2" />
                          {{ "contract.start" | translate }}
                        </a>
                      </li>
                      <li *ngIf="!value.instance.status">
                        <a href="javascript:;" *hlMenuItem="let menuItem" (click)="deleteInstance(value.id)">
                          <icon-circle-stop class="shrink-0 ltr:mr-2 rtl:ml-2" />
                          {{ "contract.stop" | translate }}
                        </a>
                      </li>
                    </div>
                    <li *appHasRole="[userRole.SuperAdmin]">
                      <a href="javascript:;" *hlMenuItem="let menuItem" (click)="openDeleteModal(value.id)">
                        <icon-trash-lines class="shrink-0 ltr:mr-2 rtl:ml-2" />
                        {{ "delete_quick_label" | translate }}
                      </a>
                    </li>
                  </app-message-portal>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-datatable>
      </div>
    </div>
  </div>
</div>

<ng-template #addContractModalTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "contract.add_contract" | translate }}</div>
    <app-contract-form (closeForm)="submittedNewContract()"></app-contract-form>
  </div>
</ng-template>

<ng-template #deleteConfirmationTemplate>
  <div class="flex flex-col p-4">
    <div class="!pb-5 text-xl">{{ "contract.delete_contract" | translate }}</div>
    <div>
      <span>{{ "contract.delete_info" | translate }} </span>
      <label for="deleteCustomer"><input [(ngModel)]="deleteCustomer" id="deleteCustomer" type="checkbox" class="form-checkbox" /> Delete Customer</label>
    </div>
    <div class="mt-4 flex justify-end">
      <button class="rounded-lg bg-gray-200 px-4 py-2 text-gray-800 hover:bg-gray-300" (click)="closeDeleteModal()">{{ "cancel" | translate }}</button>
      <button class="btn btn-danger ml-3" [disabled]="isLoadingDelete" (click)="handleDelete()">
        <ng-container *ngIf="isLoadingDelete; else alternateTranslation">
          <span class="inline-block h-3 w-3 animate-ping rounded-full bg-white ltr:mr-4 rtl:ml-4"></span>
          {{ "deleting" | translate }}
        </ng-container>
        <ng-template #alternateTranslation>
          {{ "delete_quick_label" | translate }}
        </ng-template>
      </button>
    </div>
  </div>
</ng-template>
